import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  // Alinhado com MainContainers (ver pages/nova-farm/styles.js): soma real das
  // duas colunas (PrimaryContainer + gap + SecondContainer) = 1074px.
  max-width: 1074px;
`;

export const Header = styled.div`
  width: 100%;
  
  display: flex;

  @media (max-width: 992px) {
    gap: 1.5rem;
    align-items: center;
    flex-direction: column;
  }

  @media (max-width: 479px) {
    gap: 0.5rem;
  }
`;

export const FarmWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 6.25rem;
  max-width: 11.375rem;
  padding: 0.75rem 1.5rem;
  
  display: flex;
  justify-content: center;

  border-radius: 2.5rem;
  border: 0.0625rem solid black;

  @media (max-width: 48rem) {
    width: 90%;
  }

  @media (max-width: 22.5rem) {
    width: 17.5rem;
  }
`;

export const Lyrics = styled.div`
  flex-direction: column;
`;

export const FarmSelector = styled.button`
  all: unset;
  left: 0.65rem;
  top: 0.0625rem;
  position: relative;
  
  cursor: pointer;
  transition: 0.4s;

  img {
    width: 1.5rem;
    height: 1.5rem;
  }

  @media (max-width: 22.5rem) {
    margin-right: 1rem;
  }
`;

export const ContactsWrapper = styled.div`
  width: 100%;
  
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  @media (max-width: 992px) {
    justify-content: center;
  }
`;

export const Contacts = styled.div`
  gap: 1.5rem;
  display: flex;
  align-items: center;

  img {
    width: 1rem;
    height: 1rem;
    cursor: pointer;
  }

  @media (max-width: 494px) {
    flex-direction: column;
  }
`;

export const IconsWrapper = styled.div`
  gap: 1.5rem;
  display: flex;
  align-items: center;
`

export const Share = styled.button`
  all: unset;
  padding: 0.75rem 1.5rem;
  
  gap: 0.5rem;
  display: flex;
  align-items: center;

  cursor: pointer;
  border-radius: 2.5rem;
  text-transform: uppercase;
  border: 0.0625rem solid black;

  p {
    cursor: pointer;
  }
`;

export const ContainerButtons = styled.div`
  width: auto;
  height: auto;

  gap: 1rem;
  display: flex;
  align-items: center;

  @media (max-width: 760px) {
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (max-width: 479px) {
    gap: 0.5rem;
  }
`;

export const ContainerSelect = styled.div`
  width: auto;
  height: auto;
  min-width: 280px;
`;

export const Button = styled.button`
    all: unset;

    width: 100%;
    height: 24px;
    max-width: 10.375rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    border-radius: 1.625rem;
    background-color: ${props => props.disabled ? theme.colors.disabled.Fundo_Desabilitado : "#2FBB69"};

    position: relative;

    >img{
        height: auto;
        width: 1.25rem;
    }

    >p{
        cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
        
        text-align: center;
    }

    @media (max-width: 350px) {
      padding: 0.75rem 0;
    }
`

export const Button2 = styled.button`
  padding: 0.5rem 1rem;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  cursor: pointer;
  border-radius: 1.563rem;
  border: 1px solid ${theme.colors.gray.Cinza_2};
  background-color: ${theme.colors.white.Branco};
  transition: background-color 0.3s ease;
  
  >p{
    cursor: pointer;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const Icon = styled.img`
  width: 1.25rem;
  height: 1.25rem;
  
  margin-right: 0.625rem;
`;

export const ButtonSecundary = styled.button`
    all: unset;

    width: auto;
    height: 14px;
    min-width: 70px;
    max-width: 165px;
    padding: 12px 24px;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1.625rem;

    position: relative;

    border: 1px solid ${theme.colors.gray.Cinza_2};
    >img{
      width: 1rem;
      height: auto;
    }
`
export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: ${props => props.width ? props.width : '20px'};
  height: ${props => props.height ? props.height : '20px'};
  position: relative;

  background-color: transparent;
  border-top: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-bottom: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;
